<span class="sim-button-wrapper">
  <ng-content />
  <ng-content select="sim-button-loader" />
</span>
